import axios from 'axios';

export const getAccessToken = () =>
  localStorage.getItem('access_token') || sessionStorage.getItem('access_token');

export const getRefreshToken = () =>
  localStorage.getItem('refresh_token') || sessionStorage.getItem('refresh_token');

export const clearTokens = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  sessionStorage.removeItem('access_token');
  sessionStorage.removeItem('refresh_token');
};

export const refreshToken = async () => {
  const refresh = getRefreshToken();
  if (!refresh) throw new Error('No refresh token available');

  const baseURL = process.env.REACT_APP_API_ENDPOINT;
  const response = await axios.post(`${baseURL}/auth/jwt/refresh/`, { refresh });
  const { access } = response.data;

  // Replace access token in storage
  if (localStorage.getItem('refresh_token')) {
    localStorage.setItem('access_token', access);
  } else {
    sessionStorage.setItem('access_token', access);
  }

  // Update axios header
  axios.defaults.headers.common['Authorization'] = `Bearer ${access}`;
  return response;
};
